import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["setForgeDoc", "setError", "accountId", "apolloClient", "contextIds", "extension", "components", "coreData", "extensionData", "extensionPayload", "extensionViewData", "getContextToken", "timezone", "locale", "bridge"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef } from 'react';
import { Iframe } from '../iframe';
import { fg } from '@atlaskit/platform-feature-flags';
import { useCallbackOne } from 'use-memo-one';
export var WebRuntime = function WebRuntime(_ref) {
  var setForgeDoc = _ref.setForgeDoc,
    setError = _ref.setError,
    accountId = _ref.accountId,
    apolloClient = _ref.apolloClient,
    contextIds = _ref.contextIds,
    extension = _ref.extension,
    components = _ref.components,
    coreData = _ref.coreData,
    extensionData = _ref.extensionData,
    extensionPayload = _ref.extensionPayload,
    extensionViewData = _ref.extensionViewData,
    getContextToken = _ref.getContextToken,
    timezone = _ref.timezone,
    locale = _ref.locale,
    bridge = _ref.bridge,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var forgeReactMajorVersion = useRef(null);
  // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
  var macroConfigUpdateImprovementEnabled = fg('forge-ui-macro-config-update-improvement');
  var combinedBridge = _objectSpread(_objectSpread({
    onError: function onError(_ref2) {
      var error = _ref2.error;
      if (setError) {
        setError(error);
      }
    }
  }, bridge), {}, {
    reconcile: function reconcile(_ref3) {
      var forgeDoc = _ref3.forgeDoc;
      Object.freeze(forgeDoc);
      setForgeDoc(forgeDoc);
      if (macroConfigUpdateImprovementEnabled && forgeReactMajorVersion.current === null && forgeDoc.forgeReactMajorVersion) {
        forgeReactMajorVersion.current = forgeDoc.forgeReactMajorVersion;
      }
    }
  });
  var getCurrentForgeReactMajorVersion = useCallbackOne(function () {
    return forgeReactMajorVersion.current;
  }, [forgeReactMajorVersion]);
  return /*#__PURE__*/React.createElement(Iframe, _extends({
    accountId: accountId,
    apolloClient: apolloClient,
    contextIds: contextIds,
    extension: extension,
    coreData: coreData,
    components: components,
    extensionData: extensionData,
    extensionPayload: extensionPayload,
    extensionViewData: extensionViewData,
    getContextToken: getContextToken,
    timezone: timezone,
    locale: locale,
    bridge: combinedBridge,
    isHidden: true,
    getCurrentForgeReactMajorVersion: macroConfigUpdateImprovementEnabled ? getCurrentForgeReactMajorVersion : undefined
  }, restProps));
};